// extracted by mini-css-extract-plugin
module.exports = {"dateSeparator":"DateSeparator_dateSeparator__dJutk","date":"DateSeparator_date__1Hx4q"};